<span
  class="notes__header"
  [class.notes__header--open]="isOpen"
  *ngIf="header"
  (click)="toggleBody()"
  >{{ header }}{{ isOpen ? body : body ? '...' : '' }}
  <svg
    *ngIf="body && !isOpen"
    xmlns="http://www.w3.org/2000/svg"
    class="notes__arrow"
    viewBox="0 0 512 512"
  >
    <title></title>
    <path
      d="M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
    />
  </svg>
  <svg
    *ngIf="body && isOpen"
    [class.notes__arrow--open]="isOpen"
    xmlns="http://www.w3.org/2000/svg"
    class="notes__arrow"
    viewBox="0 0 512 512"
  >
    <title></title>
    <path
      d="M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
    />
  </svg>
</span>

<!--<p (click)="toggleBody()" class="notes__body" [class.notes__body&#45;&#45;open]="!isOpen" *ngIf="body">-->
<!--  {{ body }}-->
<!--</p>-->
